import { render, staticRenderFns } from "./DanniAuto.vue?vue&type=template&id=8f3ff8cc&"
import script from "./DanniAuto.vue?vue&type=script&lang=ts&"
export * from "./DanniAuto.vue?vue&type=script&lang=ts&"
import style0 from "./DanniAuto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports